import { Label, Layout, Panel } from "@mcleod/components";

export abstract class AutogenLayoutSubmittalExceptionPanel extends Layout {
    labelException: Label;
    labelHeader: Label;
    panelSubmittalException: Panel;
}
